import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

export default function PreguntasFrec() {
  const [fontSizes, setFontSizes] = useState(16);

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };

  return (
    <>
      <div className={"font-" + fontSizes}>
        <div className="container bordes-card pt-5 pb-5 mb-5">
          <Accordion className="pt-4 preguntas-frecuentes">
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="0">
                <h5>
                  {" "}
                  En qué horarios está abierto el Santuario y cómo llegar?
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <p>
                    De lunes a domingos de 8:00 a 18:00 horas. Se puede llegar
                    desde la ciudad por el Barrio Tres Cerritos, en vehículo
                    particular o en taxi/remis o caminando. La distancia desde
                    el centro hasta la cima es de 7 km y existen actualmente
                    líneas urbana de colectivos Línea 5A y 5B desde el centro de
                    la ciudad hasta el pie del cerro.
                  </p>
                  <ul>
                    <li>
                      Los días Sábados, se puede llegar hasta el Santuario en
                      vehículos propios, taxis o remises hasta la puerta de
                      acceso al Santuario; desde ahí en más está permitido
                      subir, en este tiempo de pandemia, a pie.
                    </li>
                    <li>
                      Los días de Semana desde la puerta de acceso al Santuario
                      se puede acceder a pie, en auto particular en taxis o
                      remises (al llegar a un determinado lugar del Santuario
                      serán guiados para llegar hasta arriba).
                    </li>
                  </ul>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="1">
                <h5>Hay actividad los días Sábados?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <p>
                    Todos los sábados se realiza el Rezo del Santo Rosario en el
                    Santuario a horas 12:00, el que también se transmite por
                    nuestro canal de YouTube.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="2">
                <h5>Hay estacionamiento para vehículos?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <p>
                    Sí. El primer estacionamiento denominado “La Providencia”
                    está ubicado en un punto intermedio entre la base del cerro
                    y la cima del mismo, donde se encuentra construido el
                    Santuario. Tiene una capacidad de estacionar 200 ómnibus de
                    larga distancia y autos particulares. Está habilitado los
                    días Sábados de 8 a 18hs, Domingos y Feriados de 8 a 18hs.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="3">
                <h5>Puedo subir en taxi/remis hasta el Santuario?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <p>
                    Se puede subir al Santuario en vehículos particulares, taxis
                    o remises de domingo a viernes, y el sábado a partir de las
                    14:00hs a 18:00hs. En el Santuario serán guiados por
                    guardias o Servidores para estos casos.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="4">
                <h5>Hay traslados de impedidos?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  <p>
                    Los días Sábados hay transporte para impedidos en Colectivos
                    Saeta y Camionetas de 8:00 a 17:30hs.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="5">
                <h5>Hay rezo del Rosario por Internet?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="5">
                <Card.Body>
                  <p>
                    Se Reza el Santo Rosario en comunidad los días Sábados a las
                    12.00hs y se transmite por nuestro Canal Oficial de YouTube:{" "}
                    <a
                      href="https://youtube.com/@ObraInmaculadaMadreIMCEJySACEJ"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://youtube.com/@ObraInmaculadaMadreIMCEJySACEJ
                    </a>
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="6">
                <h5>Se puede sacar fotos en el santuario y/o filmar?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="6">
                <Card.Body>
                  <p>
                    Se puede sacar fotos y filmar para uso personal del
                    peregrino como en cualquier Santuario del mundo. Se ruega
                    tener en cuenta que es un lugar de oración y recogimiento,
                    como también el Santuario recomienda no filmar ni sacar
                    fotos a otros peregrinos presentes para cuidar la privacidad
                    de las personas. No está permitido realizar filmaciones o
                    fotos para utilizar en actividades comerciales y otros fines
                    publicitarios que no tengan nada que ver con la Obra
                    Oficial. <br />
                    No se permite realizar transmisiones en vivo para subir a
                    las redes sociales o sitios webs que sean de alcance
                    público. No se permite realizar streaming de ningún tipo.
                    <br />
                    Se puede realizar una video llamada para un familiar enfermo.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="7">
                <h5>
                  Cómo consigo Estampas y otros objetos de devoción en el
                  Santuario?
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  <p>
                    En el Santuario hay a disposición Estampas oficiales de la
                    Obra que son de distribución gratuita. <br />
                    Se pueden obtener imágenes de la Virgen realizadas a mano en
                    el Monasterio San Bernardo de Carmelitas Descalzas, y otros
                    objetos de devoción.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="8">
                <h5>
                  Qué comodidades hay en el Santuario? Puedo comprar algo para
                  comer o beber?
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="8">
                <Card.Body>
                  <p>
                    En el Santuario de La Inmaculada Madre no existen lugares de
                    comidas, bebidas, o ventas de ningún tipo. Se provee de
                    forma gratuita agua natural siempre que el peregrino lleve
                    su vaso para uso personal. Rogamos a los señores peregrinos
                    evitar tomar mate, realizar actividades sociales, picnics,
                    etc, y mantener el silencio, la contemplación, el rezo
                    interior para cuidar la mística y el recogimiento que existe
                    en el lugar. <br />
                    En la cima: el Santuario ofrece gratuitamente baños químicos
                    muy cuidados en su aseo. <br />
                    No se admite ofrecer limosnas de agradecimiento ni entregas
                    de dinero, joyas, regalos, ni dádivas de ningún tipo a
                    servidores con uniforme: pañuelo celeste y credenciales de
                    la Obra, a guardias de seguridad, policías, empleados u
                    otras personas. En el Santuario no existen personas
                    nombradas oficialmente para recibir ningún tipo de
                    donaciones en dinero, joyas, regalos, etc. <br />
                    La Obra tiene una cuenta oficial para hacer depósitos de
                    donaciones de dinero por promesas o agradecimientos a la
                    Virgen, o colaboración para el sostenimiento del Santuario.
                    <br />
                    En el Santuario existen dos buzones al lado de la Capilla
                    para colocar las intenciones, promesas, votos, etc.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="9">
                <h5>
                  Cómo consigo los mensajes que la Virgen le está dando a la
                  Sra. María Livia?
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="9">
                <Card.Body>
                  <p>
                    Se pueden leer los Mensajes dados por la Santísima Virgen
                    directamente por la aplicación oficial para celulares o
                    dispositivos móviles accediendo por el Menú a la Sección
                    “MENSAJES DE LA SANTÍSIMA VIRGEN Y DE NUESTRO SEÑOR
                    JESUCRISTO”. Los mensajes también están disponibles en el
                    Sitio Oficial tanto para leer por la web o para imprimir.
                    <br />
                    Hay mensajes dados por la Santísima Virgen a partir del año
                    2.003 que están en proceso de análisis por la autoridad
                    eclesiástica del lugar, que no han sido publicados aún.
                    <br />
                    La Santísima Virgen, Inmaculada Madre del Divino Corazón
                    Eucarístico de Jesús, continúa manteniendo comunicación con
                    la Sra. María Livia Galliano de Obeid en la ciudad de Salta,
                    República Argentina.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="10">
                <h5>Cómo puedo contactarme con ustedes?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="10">
                <Card.Body>
                  <p>
                    Pueden contactarse por medio de esta aplicación de la
                    siguiente manera:
                    <br />
                    La opción CONTACTO para enviar consultas, pedidos de soporte
                    o sugerencias.
                    <br />
                    La opción PEDIDOS DE ORACIÓN es para enviar pedidos de
                    oración. Los correos recibidos con pedidos de oración son
                    entregados a la Sra. María Livia quien se los presenta a la
                    Santísima Virgen a diario.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="11">
                <h5>
                  Me gustaría trabajar para servir a la Virgen en el Santuario
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="11">
                <Card.Body>
                  <p>
                    Pueden comunicarse por la opción CONTACTO, por EMAIL, si
                    vives en la Ciudad de Salta, los días Sábados contactarte
                    con las personas itinerantes de subcoordinación en el
                    Santuario.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="12">
                <h5>Los jóvenes pueden ingresar a la Obra?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="12">
                <Card.Body>
                  <p>
                    Sí, los jóvenes pueden ingresar a la Obra, si su corazón
                    siente el llamado del Corazón Inmaculado de María. Una vez
                    vinculados al servicio voluntario de Servidores formarás
                    parte de un grupo llamado “SERVIDORES DE LA SANTÍSIMA VIRGEN
                    INMACULADA MADRE DEL DIVINO CORAZÓN EUCARÍSTICO DE JESÚS”.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="13">
                <h5>
                  Hay Servidores de otras ciudades argentinas o de otros países?
                </h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="13">
                <Card.Body>
                  <p>
                    Existen actualmente más de 700 servidores distribuidos en
                    las distintas provincias argentinas y en otros países del
                    mundo.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="14">
                <h5>Cómo ser Servidor?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="14">
                <Card.Body>
                  <p>
                    Pueden comunicarse por la opción CONTACTO, por EMAIL, si
                    vives en la Ciudad de Salta, los días Sábados contactarte
                    con las personas itinerantes de subcoordinación en el
                    Santuario.
                    <br />
                    Después de este primer paso se te contactará para comenzar
                    siendo Postulante.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="15">
                <h5>Cómo colaborar para el sustento del Santuario?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="15">
                <Card.Body>
                  <p>
                    Existe una cuenta bancaria oficial. <br />
                    <strong>Banco Macro Bansud</strong>
                    <br />
                    <strong>Cta. Ctte. Especial N°</strong> 410009403720047
                    <br />
                    <strong>CBU</strong> 2850100640094037200478
                    <br />
                    <strong>ALIAS CBU:</strong> SERIE.CAMISA.CICLO
                    <br />
                    <strong>CUIT</strong> 30-70962039-4
                  </p>
                  <p>
                    No existen personas, ni otras cuentas bancarias, ni
                    instituciones, ni órdenes religiosas, ni sitios web, ni
                    grupos en redes sociales, ni grupos de oración, ni agencias
                    de turismo, ni turismo religioso, ni coordinadores,
                    misioneros, guías de grupo, etc. autorizados a recibir
                    ningún tipo de donación sea en efectivo o en especies.
                    <br />
                    Por cualquier duda sobre estas cuestiones, comunicarse por
                    CONTACTO o por EMAIL.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="16">
                <h5>Qué otro material existe para conocer esta Aparición?</h5>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="16">
                <Card.Body>
                  <p>
                    Existe un folleto en esta aplicación donde se explica
                    brevemente la HISTORIA DE LAS APARICIONES DE LA SANTÍSIMA
                    VIRGEN Y DE NUESTRO SEÑOR JESUCRISTO EN SALTA ARGENTINA.
                    <br />
                    Libros escritos por Monseñor Rene Laurentin, teólogo,
                    exégeta, historiador, especialista en apariciones marianas,
                    que publicó más de 130 obras sobre el tema de distintas
                    partes del mundo.
                  </p>
                  <ul>
                    <li>Libro <strong>“SE APARECE LA VIRGEN EN SALTA?”</strong>, publicado en 2.010, Ed. Bonum, Rene Laurentin.</li>
                    <li>Libro <strong>“GENESIS DE SALTA”</strong>, publicado en 2.012, Ed. Bonum, Rene Laurentin.</li>
                    <li>Libro <strong>“ANTECEDENTES DE LAS APARICIONES EN SALTA”</strong>, publicado en 2.014, Ed. Mundo Gráfico, Rene Laurentin.</li>
                  </ul>
                  <p>Diccionario de las Apariciones de la Virgen María: <strong>“DICTIONAIRE DES “APARITIONS” DE LA VIERGE MERIE”</strong>, publicado en Junio 2012, René Laurentin y Patrick Sbalchiero, Editorial Fayard.</p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
